// extracted by mini-css-extract-plugin
export default {"errorMessage":"b1ZX9C","errorIcon":"c1ZX9C"};